module.exports = __webpack_public_path__ + "img/rightArrow.e423c033.svg";